export default __webpack_public_path__ + "static/hik-softver-95f63c551848d5cb45f5bb3a1b377ecd.png";